<template>
  <div id="app" :class="{ 'acceptance-mode': acceptance }">
    <div v-if="acceptance" class="acceptance-notice">{{ environmentNotice }}</div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    acceptance: process.env.VUE_APP_ACCEPTANCE === 'true',
    environmentNotice: process.env.VUE_APP_PAYMENT_TESTING === 'true'
      ? '支付测试环境 · 微信真实扣款，独立测试账本'
      : '验收环境 · 数据为快照，不与旧 Bot 实时同步'
  })
}
</script>

<style>
.acceptance-notice { position: fixed; z-index: 5000; top: 0; left: 0; right: 0; padding: 4px 8px; background: #e6f3ff; color: #295a7e; font-size: 11px; line-height: 18px; text-align: center; pointer-events: none; }
#app.acceptance-mode { padding-top: 26px; }
@media (min-width: 901px) {
  .acceptance-mode .page { min-height: calc(100dvh - 26px); }
  .acceptance-mode .layout, .acceptance-mode .sidebar { height: calc(100dvh - 26px); }
  .acceptance-mode .main { height: calc(100dvh - 90px); }
}
:root {
  --ui-canvas: #f4f7fb;
  --ui-surface: #ffffff;
  --ui-surface-soft: #f8fbff;
  --ui-tint: #eef5ff;
  --ui-border: #dfe7f1;
  --ui-text: #20324d;
  --ui-muted: #667890;
  --ui-primary: #3487e4;
  --ui-primary-strong: #216fc9;
  --ui-accent: #216fc9;
  --ui-success-soft: #effaf5;
  --ui-success-border: #bcebd3;
  --ui-warning-soft: #fff8ed;
  --ui-warning-border: #f5dcaf;
  --ui-shadow: 0 8px 28px rgba(28, 54, 91, 0.055);
  font-family: 'Manrope', 'Segoe UI', 'Helvetica Neue', Arial, sans-serif;
  color: var(--ui-text);
  background: var(--ui-canvas);
}

html, body, #app {
  height: 100%;
  margin: 0;
  background: var(--ui-canvas);
}

html {
  -webkit-text-size-adjust: 100%;
}

*, *::before, *::after {
  box-sizing: border-box;
}

body {
  color: var(--ui-text);
  overscroll-behavior-y: none;
  -webkit-tap-highlight-color: rgba(59, 130, 246, 0.14);
  -webkit-font-smoothing: antialiased;
}

body.dark-mode {
  --ui-canvas: #101a2a;
  --ui-surface: #1b283a;
  --ui-surface-soft: #162235;
  --ui-tint: #233c5b;
  --ui-border: #34475f;
  --ui-text: #e9f0fa;
  --ui-muted: #afbdd0;
  --ui-primary: #3479cc;
  --ui-primary-strong: #488fe0;
  --ui-accent: #9ac8fb;
  --ui-success-soft: #17332f;
  --ui-success-border: #2d6958;
  --ui-warning-soft: #382c1d;
  --ui-warning-border: #71502e;
  --ui-shadow: 0 8px 28px rgba(0, 0, 0, 0.16);
}

.el-button--primary:not(.is-plain) {
  background: var(--ui-primary);
  border-color: var(--ui-primary);
}

.el-button--primary:not(.is-plain):hover,
.el-button--primary:not(.is-plain):focus {
  background: var(--ui-primary-strong);
  border-color: var(--ui-primary-strong);
}

.el-button,
.el-input__inner,
.el-textarea__inner,
.el-select-dropdown,
.el-dialog {
  border-radius: 10px;
}

.el-card {
  border-radius: 16px;
  box-shadow: var(--ui-shadow);
}

/* Light theme overrides for Element UI */
.el-card {
  background-color: var(--ui-surface) !important;
  border-color: var(--ui-border) !important;
  color: var(--ui-text) !important;
}

.el-menu {
  background-color: var(--ui-surface) !important;
  border-right: solid 1px var(--ui-border) !important;
}

.el-menu-item {
  color: var(--ui-muted) !important;
}

.el-menu-item:hover, .el-menu-item:focus {
  background-color: var(--ui-tint) !important;
  color: var(--ui-primary-strong) !important;
}

.el-menu-item.is-active {
  color: var(--ui-primary-strong) !important;
  background-color: var(--ui-tint) !important;
}

.el-input__inner {
  background-color: var(--ui-surface) !important;
  border-color: var(--ui-border) !important;
  color: var(--ui-text) !important;
}

.el-form-item__label {
  color: var(--ui-muted) !important;
}

.el-table {
  background-color: #ffffff !important;
  color: #1f2937 !important;
}

.el-table th {
  background-color: #f8fafc !important;
  color: #4b5563;
}

.el-table tr {
  background-color: #ffffff !important;
}

.el-table td, .el-table th.is-leaf {
  border-bottom: 1px solid #f1f5f9 !important;
}

.el-table td {
  padding: 12px 0;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f1f5f9 !important;
}

body.dark-mode,
body.dark-mode #app {
  background: var(--ui-canvas);
  color: var(--ui-text);
}

body.dark-mode .el-card {
  background-color: var(--ui-surface) !important;
  border-color: var(--ui-border) !important;
  color: var(--ui-text) !important;
}

body.dark-mode .el-card__header {
  border-bottom-color: #334155 !important;
}

body.dark-mode .el-menu {
  background-color: var(--ui-surface) !important;
  border-right-color: var(--ui-border) !important;
}

body.dark-mode .el-menu-item {
  color: #cbd5e1 !important;
}

body.dark-mode .el-menu-item:hover,
body.dark-mode .el-menu-item:focus {
  background-color: #1e293b !important;
  color: #bfdbfe !important;
}

body.dark-mode .el-menu-item.is-active {
  color: #93c5fd !important;
  background-color: rgba(59, 130, 246, 0.18) !important;
}

body.dark-mode .el-input__inner,
body.dark-mode .el-textarea__inner {
  background-color: var(--ui-surface-soft) !important;
  border-color: var(--ui-border) !important;
  color: var(--ui-text) !important;
}

body.dark-mode .el-select .el-input__inner,
body.dark-mode .el-date-editor .el-input__inner,
body.dark-mode .el-input-group__append,
body.dark-mode .el-input-group__prepend {
  background-color: #0f172a !important;
  border-color: #334155 !important;
  color: #e5e7eb !important;
}

body.dark-mode .el-input__inner:hover,
body.dark-mode .el-textarea__inner:hover,
body.dark-mode .el-select:hover .el-input__inner {
  border-color: #475569 !important;
}

body.dark-mode .el-input.is-focus .el-input__inner,
body.dark-mode .el-input__inner:focus,
body.dark-mode .el-textarea__inner:focus,
body.dark-mode .el-select .el-input.is-focus .el-input__inner {
  border-color: #60a5fa !important;
  box-shadow: 0 0 0 2px rgba(96, 165, 250, 0.14);
}

body.dark-mode .el-input__inner::placeholder,
body.dark-mode .el-textarea__inner::placeholder {
  color: #94a3b8 !important;
}

body.dark-mode .el-input.is-disabled .el-input__inner,
body.dark-mode .el-textarea.is-disabled .el-textarea__inner {
  background-color: #111827 !important;
  border-color: #253247 !important;
  color: #64748b !important;
}

body.dark-mode .el-select .el-input .el-select__caret,
body.dark-mode .el-input__icon {
  color: #94a3b8 !important;
}

body.dark-mode .el-form-item__label,
body.dark-mode .el-checkbox,
body.dark-mode .el-radio {
  color: #cbd5e1 !important;
}

body.dark-mode .el-table {
  background-color: #111827 !important;
  color: #e5e7eb !important;
  border-color: #334155 !important;
}

body.dark-mode .el-table th,
body.dark-mode .el-table__header-wrapper th {
  background-color: #1e293b !important;
  color: #e2e8f0 !important;
}

body.dark-mode .el-table tr,
body.dark-mode .el-table__body tr {
  background-color: #111827 !important;
}

body.dark-mode .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #172033 !important;
}

body.dark-mode .el-table td,
body.dark-mode .el-table th.is-leaf {
  border-bottom-color: #263244 !important;
}

body.dark-mode .el-table td,
body.dark-mode .el-table .cell {
  color: #dbeafe !important;
}

body.dark-mode .el-table--border,
body.dark-mode .el-table--group {
  border-color: #334155 !important;
}

body.dark-mode .el-table--border td,
body.dark-mode .el-table--border th,
body.dark-mode .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border-right-color: #263244 !important;
}

body.dark-mode .el-table::before,
body.dark-mode .el-table::after,
body.dark-mode .el-table__fixed-right::before,
body.dark-mode .el-table__fixed::before {
  background-color: #334155 !important;
}

body.dark-mode .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #22304a !important;
}

body.dark-mode .el-dialog,
body.dark-mode .el-message-box,
body.dark-mode .el-picker-panel,
body.dark-mode .el-select-dropdown,
body.dark-mode .el-dropdown-menu {
  background: #111827 !important;
  border-color: #334155 !important;
  color: #e5e7eb !important;
}

body.dark-mode .el-dialog__title,
body.dark-mode .el-message-box__title,
body.dark-mode .el-dialog__body,
body.dark-mode .el-message-box__content,
body.dark-mode .el-select-dropdown__item {
  color: #e5e7eb !important;
}

body.dark-mode .el-select-dropdown__empty,
body.dark-mode .el-table__empty-text,
body.dark-mode .el-pagination__total,
body.dark-mode .el-pagination__jump,
body.dark-mode .el-pagination button,
body.dark-mode .el-pagination span:not([class*=suffix]) {
  color: #94a3b8 !important;
}

body.dark-mode .el-select-dropdown__item.hover,
body.dark-mode .el-select-dropdown__item:hover,
body.dark-mode .el-dropdown-menu__item:hover {
  background-color: #1e293b !important;
  color: #bfdbfe !important;
}

body.dark-mode .el-select-dropdown__item.selected {
  color: #93c5fd !important;
}

body.dark-mode .el-tag {
  border-color: rgba(148, 163, 184, 0.34) !important;
  background-color: rgba(148, 163, 184, 0.14) !important;
  color: #cbd5e1 !important;
}

body.dark-mode .el-tag--success {
  border-color: rgba(34, 197, 94, 0.34) !important;
  background-color: rgba(34, 197, 94, 0.14) !important;
  color: #86efac !important;
}

body.dark-mode .el-tag--warning {
  border-color: rgba(245, 158, 11, 0.36) !important;
  background-color: rgba(245, 158, 11, 0.16) !important;
  color: #fcd34d !important;
}

body.dark-mode .el-tag--danger {
  border-color: rgba(248, 113, 113, 0.36) !important;
  background-color: rgba(248, 113, 113, 0.16) !important;
  color: #fca5a5 !important;
}

body.dark-mode .el-button--default,
body.dark-mode .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):not(.el-button--info):not(.el-button--text) {
  background-color: #111827;
  border-color: #334155;
  color: #cbd5e1;
}

body.dark-mode .el-button--default:hover,
body.dark-mode .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):not(.el-button--info):not(.el-button--text):hover {
  background-color: #1e293b;
  border-color: #475569;
  color: #e5e7eb;
}

body.dark-mode .el-pagination.is-background .btn-prev,
body.dark-mode .el-pagination.is-background .btn-next,
body.dark-mode .el-pagination.is-background .el-pager li {
  background-color: #1e293b !important;
  color: #cbd5e1 !important;
}

body.dark-mode .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #3b82f6 !important;
  color: #fff !important;
}

body:not(.dark-mode) .el-card {
  background-color: var(--ui-surface) !important;
  border-color: var(--ui-border) !important;
  color: var(--ui-text) !important;
}

body:not(.dark-mode) .el-input__inner,
body:not(.dark-mode) .el-textarea__inner,
body:not(.dark-mode) .el-select .el-input__inner {
  background-color: var(--ui-surface) !important;
  border-color: var(--ui-border) !important;
  color: var(--ui-text) !important;
  box-shadow: none;
}

body:not(.dark-mode) .el-table,
body:not(.dark-mode) .el-table__body,
body:not(.dark-mode) .el-table__footer,
body:not(.dark-mode) .el-table__header {
  background-color: var(--ui-surface) !important;
  color: var(--ui-text) !important;
  border-color: var(--ui-border) !important;
}

body:not(.dark-mode) .el-table th,
body:not(.dark-mode) .el-table__header-wrapper th {
  background-color: var(--ui-surface-soft) !important;
  color: var(--ui-muted) !important;
  border-bottom-color: var(--ui-border) !important;
}

body:not(.dark-mode) .el-table tr,
body:not(.dark-mode) .el-table__body tr,
body:not(.dark-mode) .el-table td {
  background-color: var(--ui-surface) !important;
  color: var(--ui-text) !important;
  border-color: var(--ui-border) !important;
}

body:not(.dark-mode) .el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #fafafa !important;
}

body:not(.dark-mode) .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #f1f5f9 !important;
}

body:not(.dark-mode) .el-table .cell {
  color: var(--ui-text) !important;
}

body:not(.dark-mode) .el-tag:not(.el-tag--success):not(.el-tag--warning):not(.el-tag--danger) {
  background-color: var(--ui-tint) !important;
  border-color: var(--ui-border) !important;
  color: var(--ui-primary-strong) !important;
}

.mobile-page-size-popper {
  min-width: 74px !important;
  padding: 0 !important;
  border-radius: 2px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18) !important;
  border-color: #dcdfe6 !important;
}

.mobile-page-size-menu {
  display: grid;
  gap: 0;
  background: #ffffff;
}

.mobile-page-size-menu button {
  height: 38px;
  border: 0;
  border-radius: 0;
  background: transparent;
  color: #606266;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  padding: 0 13px;
}

.mobile-page-size-menu button.active {
  background: #f5f7fa;
  color: #409eff;
  font-weight: 700;
}

@media (max-width: 900px) {
  html,
  body,
  #app {
    height: auto;
    min-height: 100%;
    min-height: 100dvh;
  }

  .el-button,
  .el-button--small,
  .el-button--mini {
    min-width: 44px;
    min-height: 44px;
  }

  .el-input__inner,
  .el-select .el-input__inner {
    min-height: 44px;
    line-height: 44px;
    font-size: 16px !important;
  }

  .el-textarea__inner { font-size: 16px !important; }

  .el-dialog__headerbtn { width: 44px; height: 44px; top: 4px; right: 4px; }

  .el-dialog {
    width: calc(100vw - 24px) !important;
    max-width: 720px;
    margin-top: 6vh !important;
  }

  .el-dialog__wrapper {
    box-sizing: border-box;
    padding: max(12px, env(safe-area-inset-top)) 12px calc(12px + env(safe-area-inset-bottom));
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .el-dialog__body {
    padding: 14px !important;
    max-width: 100%;
    overflow-x: hidden;
  }

  .el-dialog__header,
  .el-dialog__footer {
    padding-left: 14px !important;
    padding-right: 14px !important;
  }

  .el-message {
    min-width: 0 !important;
    width: calc(100vw - 24px) !important;
  }

  .el-message-box {
    width: calc(100vw - 28px) !important;
    max-width: 420px;
  }

  .el-select-dropdown,
  .el-picker-panel {
    max-width: calc(100vw - 24px);
  }
}

@media (max-width: 640px) {
  html,
  body {
    overflow-x: hidden;
  }

  .el-card__body {
    padding: 12px !important;
  }

  .el-form-item {
    margin-bottom: 14px;
  }

  .el-form-item__label {
    float: none;
    display: block;
    width: 100% !important;
    padding: 0 0 6px;
    line-height: 1.35;
    text-align: left !important;
  }

  .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-input__inner,
  .el-textarea__inner,
  .el-select .el-input__inner {
    font-size: 16px !important;
  }

  .el-button {
    min-height: 44px;
  }

  .el-button--small,
  .el-button--mini {
    min-height: 44px;
  }

  .el-dialog {
    width: calc(100vw - 20px) !important;
    margin: max(18px, env(safe-area-inset-top)) auto calc(18px + env(safe-area-inset-bottom)) !important;
    border-radius: 14px;
  }

  .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
    width: 44px;
    height: 44px;
  }

  .el-dialog__close {
    font-size: 18px;
  }

  .el-dialog__footer .el-button {
    margin-left: 0;
  }

  .el-dialog__footer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    flex-wrap: wrap;
    padding-bottom: calc(14px + env(safe-area-inset-bottom)) !important;
  }

  .el-pagination {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 6px;
  }

  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .el-pager li {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    margin: 0 2px;
  }

  .el-table .cell {
    line-height: 1.45;
  }
}

@supports (-webkit-touch-callout: none) {
  html,
  body,
  #app {
    min-height: -webkit-fill-available;
  }
}
</style>
